var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPricingcard1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 53,
    height: 53,
    viewBox: "0 0 53 53",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.434204,
    y: 0.856445,
    width: 51.8193,
    height: 51.8193,
    rx: 25.9096,
    fill: "url(#paint0_radial_136_1558)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_136_1558)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.3438 11.9604C26.567 20.0431 33.0667 26.5428 41.1493 26.7659C33.0667 26.9891 26.567 33.4888 26.3438 41.5714C26.1207 33.4888 19.6209 26.9891 11.5383 26.7659C19.6209 26.5428 26.1207 20.0431 26.3438 11.9604Z",
    fill: "url(#paint1_radial_136_1558)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_136_1558",
    x: 5.98627,
    y: 10.1098,
    width: 40.7151,
    height: 40.715,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3.70138
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.77603
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.0038961 0 0 0 0 0.576623 0 0 0 0 0.896104 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_136_1558"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_136_1558",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_136_1558",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.3438 41.1089) rotate(90) scale(30.5363)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#058BF7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#1AADFE"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_136_1558",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.3438 26.7659) rotate(90) scale(49.6554)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#006EC2"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPricingcard1);
export default __webpack_public_path__ + "static/media/pricingcard1.f86b30f7903f0313a869912362b496d4.svg";
export { ForwardRef as ReactComponent };